import React, { useMemo } from 'react';
import DropdownInnerContext from './DropdownInnerContext';
const DISPLAY_NAME = 'DropdownProvider';

/**
 * @ignore - Do not document.
 */
const DropdownInnerProvider = _ref => {
  let {
    children,
    toggle,
    keyboardNavigationProps
  } = _ref;
  const context = useMemo(() => ({
    toggle,
    keyboardNavigationProps
  }), [toggle, keyboardNavigationProps]);
  return /*#__PURE__*/React.createElement(DropdownInnerContext.Provider, {
    value: context
  }, children);
};
DropdownInnerProvider.displayName = DISPLAY_NAME;
export default DropdownInnerProvider;